import { useEffect } from 'react';

let locks = 0;
let saved = '';

/**
 * What every sheet and dialog does while it is open. Request of 5 October 2026,
 * section 4: the page behind does not scroll, and when it closes, focus goes
 * back to whatever opened it, so a keyboard or screen reader user carries on
 * from where they were.
 *
 * Counted, so a dialog opened from a sheet does not unlock the page when the
 * dialog closes and the sheet is still up.
 */
export function useOverlay(): void {
  useEffect(() => {
    const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const root = document.documentElement;
    if (locks === 0) {
      saved = root.style.overflow;
      root.style.overflow = 'hidden';
    }
    locks += 1;

    return () => {
      locks -= 1;
      if (locks === 0) root.style.overflow = saved;
      if (opener?.isConnected === true) opener.focus({ preventScroll: true });
    };
  }, []);
}
